import { render, staticRenderFns } from "./ColumnMandated.vue?vue&type=template&id=22ec1ce8"
import script from "./ColumnMandated.vue?vue&type=script&lang=js"
export * from "./ColumnMandated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22ec1ce8')) {
      api.createRecord('22ec1ce8', component.options)
    } else {
      api.reload('22ec1ce8', component.options)
    }
    module.hot.accept("./ColumnMandated.vue?vue&type=template&id=22ec1ce8", function () {
      api.rerender('22ec1ce8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/List/ColumnMandated.vue"
export default component.exports